module.exports = __webpack_public_path__ + "img/NukedTV-Web_25.ad597bbf.png";